<template>
  <div class='container'>
    <h1 class='mt-5 mb-1 text-center text-capitalize text-danger'>You do not have access on this page</h1>
  </div>
</template>

<script>
export default {
  name: 'access-denied'
};
</script>

<style scoped>

</style>